import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import headerImg from '../images/visionworks-logo.png';

// NOTE: This will be dynamic eventually
const PARTNER = 'Visionworks';

function SponsoredEcp({ href }) {
  const { t } = useTranslation();

  return createPortal(
    <Fragment>
      <div
        className='
          find-a-doctor__sponsored-banner
          find-a-doctor__sponsored-banner--foreground
        '
      >
        <a href={href} className="find-a-doctor__sponsored-ecp-link">
          &nbsp;
        </a>
      </div>
      <div
        className='
          find-a-doctor__sponsored-banner
          find-a-doctor__sponsored-banner--background
        '
      >
        <div className='find-a-doctor__sponsored-bg-color-container'>
          &nbsp;
        </div>
      </div>
      <header className="find-a-doctor__sponsored-ecp-header">
        <div className="find-a-doctor__sponsored-container">
          <section className="find-a-doctor__partner-text">
            { t('sponsored_ecp.subtext') }
          </section>
          <img
            className='find-a-doctor__sponsored-img'
            src={headerImg}
            alt={t('sponsored_ecp.alt', { partner: PARTNER })}
          />
        </div>
      </header>
    </Fragment>,
    document.querySelector('#sponsored-ecp'),
  );
}

SponsoredEcp.propTypes = {
  href: PropTypes.string.isRequired,
};

export default SponsoredEcp;
